import React from "react";
import { useReveal } from "../hooks/useReveal";
import { ArrowRight } from "lucide-react";

export default function CommoditySection({ data, flip = false, onContact }) {
  const [ref, visible] = useReveal();

  return (
    <section ref={ref} className="bg-[#f6f1e7] py-24 md:py-32 overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className={`grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center ${flip ? "lg:[&>*:first-child]:order-2" : ""}`}>
          {/* Imagery */}
          <div className={`relative reveal ${visible ? "in-view" : ""}`}>
            <div className="relative rounded-[2rem] overflow-hidden aspect-[4/5] shadow-[0_30px_60px_-20px_rgba(16,39,26,0.4)]">
              <img src={data.imageMain} alt={data.id} className="h-full w-full object-cover hover:scale-105 transition-transform duration-[1200ms]" />
              <span className="absolute top-6 left-6 font-display text-7xl text-[#f6f1e7]/80">{data.index}</span>
            </div>
            <div className="absolute -bottom-8 -right-4 md:right-8 w-40 h-40 md:w-52 md:h-52 rounded-2xl overflow-hidden border-4 border-[#f6f1e7] shadow-xl">
              <img src={data.imageInset} alt={`${data.id} detail`} className="h-full w-full object-cover" />
            </div>
          </div>

          {/* Copy */}
          <div className={`reveal ${visible ? "in-view" : ""}`} style={{ animationDelay: "0.12s" }}>
            <p className="text-[#7c5230] text-xs tracking-[0.25em] uppercase mb-6">{data.kicker}</p>
            <h2 className="font-display text-4xl md:text-6xl font-light leading-[1.02] text-[#10271a]">
              {data.pre} <em className="italic text-[#1f4a33]">{data.emphasis}</em>
            </h2>
            <p className="mt-7 text-[#5e6b61] text-lg leading-relaxed max-w-lg">{data.body}</p>

            <div className="mt-9 grid grid-cols-3 gap-6 max-w-md">
              {data.facts.map((f) => (
                <div key={f.label}>
                  <p className="text-[11px] tracking-[0.18em] uppercase text-[#7c5230] mb-1.5">{f.label}</p>
                  <p className="text-[#10271a] font-medium">{f.value}</p>
                </div>
              ))}
            </div>

            <button
              onClick={onContact}
              className="mt-10 group inline-flex items-center gap-3 text-[#1f4a33] text-sm tracking-[0.12em] uppercase font-semibold border-b-2 border-[#1f4a33]/30 pb-1 hover:border-[#1f4a33] transition-colors"
            >
              Contact for more information
              <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
